module.exports = __webpack_public_path__ + "components/flag/static/square/lv-fc72b12c4f7d13b17a2c7a21defb1691.svg";